import {useTranslation} from 'react-i18next'
import {useRoleUser} from '../../../../../hooks/useRoleUser'

export const RowHead = () => {
  const {t} = useTranslation()
  const roleUser = useRoleUser()

  return (
    <tr>
      <th>{t('No')}</th>
      <th>{t('Module')}</th>
      <th>{t('Sector')}</th>
      <th>{t('Sales Org')}</th>
      <th>{t('Jenis Produk')}</th>
      <th>{t('Batasan Tonase')}</th>
      <th>{t('Assigner Name')}</th>
      <th>{t('Assigner Position')}</th>
      <th>{t('Aksi')}</th>
    </tr>
  )
}
